import { ISimilarState } from '../store/similar';
import { hasWithoutCompetitors } from '../components/similar_offers/utils/hasWithoutCompetitors';

export function itemBasedOffersVisible(state: ISimilarState): boolean {
  return !hasWithoutCompetitors(state) && state.itemBased.list.length > 0;
}

export function someSimilarOffersVisible(state: ISimilarState): boolean {
  const itemBasedVisible = itemBasedOffersVisible(state);
  const userBasedVisible = state.userBased.list.length > 0;

  return itemBasedVisible || userBasedVisible;
}
